export const initialState = {
    is_loading: true,
    certificate_types: [],
    is_show_add_certificate_types: false,
    is_show_edit_certificate_types: false,
    error: null,
    btn_loading: false,
    selected_certificate_type: null,
    is_open_certificate_types: false
}